import { api } from './client'
import type { components } from './generated/schema'

type Profile = components['schemas']['UserResponse']

/**
 * Record that the account has been through first run.
 *
 * On the ACCOUNT rather than in `localStorage`: declining on a laptop must not
 * re-ask on a phone, and clearing site data must not resurrect a prompt already
 * answered.
 *
 * **Never throws, and the caller must not wait on it to navigate.** The worst
 * case of a failed write is being asked once more on the next sign-in. The
 * worst case of treating it as a gate is a first-run screen that will not let
 * go — which is exactly the trap this codebase has now built twice.
 */
export async function markOnboarded(): Promise<Profile | null> {
  try {
    const { data, error } = await api.PATCH('/api/v1/users/me', { body: { is_onboarded: true } })
    if (error !== undefined) {
      console.warn('Could not record that onboarding finished.', error)
      return null
    }
    return data ?? null
  } catch (thrown) {
    console.warn('Could not reach the API to record that onboarding finished.', thrown)
    return null
  }
}
